import { CreateDerivation } from "@catalogue/domain/models/derivation.model";
import { inject, injectable } from "inversify";
import { UserSessionRepository } from "@authentication/data/repositories/user-session.repository";
import { Nullable } from "@core/domain/types/nullable.type";

// Define una interfaz para la entrada si no la tienes ya
// Esto depende de dónde llames a este mapper. ¿Viene de un formulario?
interface DerivationInputValues {
    beneficiaryId: number;
    serviceId: number;
    assignedById: number;
    entityId: number;
    status?: string;
    reason?: string | null;
    documentIds?: number[];
    authorizationFileId?: number | null;
    notify_admin_id?: number;
}

@injectable()
export class CreateDerivationMapper {
    mapToCreateDto(newDerivation: CreateDerivation) {
        throw new Error("Method not implemented.");
    }
    constructor(
        @inject(UserSessionRepository)
        private readonly userSessionRepository: UserSessionRepository,
    ) { }

    map(values: DerivationInputValues): Nullable<any> {
        if (!values) return null;

        try {
            // Devuelve un objeto literal que cumple la forma de CreateDerivation
            return {
                beneficiary: values.beneficiaryId,
                service: values.serviceId,
                assigned_by: values.assignedById,
                entity: values.entityId,
                status: values.status,
                reason: values.reason,
                documents: values.documentIds || [],
                authorization_file: values.authorizationFileId,
                notify_admin_id: values.notify_admin_id || 0,
            };
        } catch (error) {
            console.error("Error mapping input values to CreateDerivation domain:", error, values);
            return null;
        }
    }

    mapFromFormValues(values: {
        beneficiaryId: number;
        serviceId: number;
        assignedById: number;
        entityId: number;
    }): CreateDerivation {
        return {
            beneficiaryId: values.beneficiaryId,
            serviceId: values.serviceId,
            assignedById: values.assignedById,
            entityId: values.entityId
        };
    }
}